/*
 * Breadcrubs Messages
 *
 * This contains all the text for the Breadcrubs component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.Breadcrubs';

export default defineMessages({
  inReview: {
    id: `${scope}.inReview`,
    defaultMessage: 'In Review',
  },
  publishedLive: {
    id: `${scope}.publishedLive`,
    defaultMessage: 'Published Live',
  },
  inReviewWithMarkets: {
    id: `${scope}.inReviewWithMarkets`,
    defaultMessage: 'In Review (Markets Exist)',
  },
  publishedLiveWithMarkets: {
    id: `${scope}.publishedLiveWithMarkets`,
    defaultMessage: 'Published Live (Markets Exist)',
  },
});
